<template>
  <crud-editor
    ref="editor"
    :definition="definition()"
    :is-edit="false"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :show-save-button="false"
    :show-save-and-next-button="false"
  />
</template>

<script>
import Select from '@/components/DSE/Select';
import CrudEditor from '@/components/crud/Editor';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import DatePicker from '@/components/DSE/DatePicker';

export default {
  components: {
    CrudEditor
  },
  data: () => ({
    entity: 'ProductionPlanningSeries',
    returnTo: 'ProductionPlanningSeries',
    form: {}
  }),
  methods: {
    saveData(form) {
      return this.$store.dispatch('productionPlanningSeries/persistItem', form);
    },
    definition() {
      return {
        domainID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'common.domain',
            valueField: 'id',
            labelField: 'name',
            options: this.$store.getters.domains
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        weekByDate: {
          type: DatePicker,
          defaultValue: null,
          props: {
            caption: 'series.weekNumber',
            type: 'week'
          },
          rules: [{ validator: validatorRequire }]
        },
        workshopID: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'common.workshop',
            valueField: 'id',
            labelField: 'name',
            options: this.$store.getters.workshops
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        planningOption: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'series.typeOfOrders',
            valueField: 'code',
            labelField: 'description',
            loading: this.$store.getters['option/isLoading'],
            options: this.$store.getters['option/loadedOptions']('planningOptions')
          },
          rules: [{ validator: validatorRequireNumber }]
        },
        returnType: {
          type: Select,
          defaultValue: null,
          props: {
            caption: 'return.returnType',
            valueField: 'code',
            labelField: 'description',
            loading: this.$store.getters['option/isLoading'],
            options: this.$store.getters['option/loadedOptions']('returnType')
          }
        },
        estimatedDeliveryDate: {
          type: DatePicker,
          defaultValue: null,
          props: {
            caption: 'planning.estimatedDeliveryDate',
            type: 'date'
          },
          rules: [{ validator: validatorRequire }]
        }
      };
    }
  }
};
</script>
